module.exports = __webpack_public_path__ + "assets/img/block-right-hover-a327e172.png";